module.exports = {
      id: "hamburger-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#hamburger",
      toString: function () {
        return this.url;
      }
    }